import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PURCHASE,
  DELETE_PURCHASE,
  UPDATE_PURCHASE,
  ADD_NEW_PURCHASE,
} from "./actionType";

import {
  getPurchaseSuccess,
  getPurchaseFail,
  deletePurchaseSuccess,
  deletePurchaseFail,
  updatePurchaseSuccess,
  updatePurchaseFail,
  addPurchaseSuccess,
  addPurchaseFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approvePurchaseApi,
  getPurchaseApi,
  updatePurchaseApi,
  deletePurchaseApi,
  addNewPurchaseApi
} from "../../helpers/backend_helper";

function* getPurchase({ payload: purchase }) {
  try {
    const response = yield call(getPurchaseApi, purchase);
    yield put(getPurchaseSuccess(GET_PURCHASE, response.data));
  } catch (error) {
    yield put(getPurchaseFail(GET_PURCHASE, error));
  }
}

function* onUpdatePurchase({ payload: purchase }) {
  try {
    if (purchase.setApprove) {
      const response = yield call(approvePurchaseApi, purchase);
      yield put(updatePurchaseSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updatePurchaseApi, purchase);
      yield put(updatePurchaseSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updatePurchaseFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeletePurchase({ payload: purchase }) {
  try {
    const response = yield call(deletePurchaseApi, purchase);
    yield put(deletePurchaseSuccess({ purchase, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deletePurchaseFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewPurchase({ payload: purchase }) {
  try {
    const response = yield call(addNewPurchaseApi, purchase);
    yield put(addPurchaseSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addPurchaseFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetPurchase() {
  yield takeEvery(GET_PURCHASE, getPurchase);
}

export function* watchUpdatePurchase() {
  yield takeEvery(UPDATE_PURCHASE, onUpdatePurchase);
}

export function* watchDeletePurchase() {
  yield takeEvery(DELETE_PURCHASE, onDeletePurchase);
}

export function* watchAddNewPurchase() {
  yield takeEvery(ADD_NEW_PURCHASE, onAddNewPurchase);
}

function* purchaseSaga() {
  yield all([
    fork(watchGetPurchase),
    fork(watchDeletePurchase),
    fork(watchUpdatePurchase),
    fork(watchAddNewPurchase)
  ]);
}

export default purchaseSaga;
